"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseJSON = void 0;
exports.ParseJSON = {
    toFile: function (name, url) {
        return {
            __type: 'File',
            name: name,
            url: url,
        };
    },
    fromFile: function (file) {
        if (file == null) {
            return null;
        }
        return file.name;
    },
    fromDate: function (json) {
        if (json == null) {
            return null;
        }
        return new Date(json.iso);
    },
    toDate: function (date) {
        if (date == null) {
            return null;
        }
        return {
            __type: 'Date',
            iso: date.toJSON(),
        };
    },
    toGeoPoint: function (location) {
        if (location == null) {
            return null;
        }
        return {
            type: 'point',
            coordinates: [location.longitude, location.latitude],
        };
    },
    fromGeoPoint: function (point) {
        if (point == null) {
            return null;
        }
        return {
            longitude: point.coordinates[0],
            latitude: point.coordinates[1],
            altitude: 0,
        };
    },
};
//# sourceMappingURL=parse.json.js.map